export default "__VITE_PUBLIC_ASSET__ad776db1__"